import React from "react";
import upperFirst from "mn-utils/upperFirst";
import {
  DisplayAmountFCMerchant,
  DisplayDateTimeMerchant,
  DisplayIdMerchant
} from "../../../../../../helpers/Display/DataDisplay";
import TerminalColorDisplay from "../../TerminalColorDisplay";
import parseCryptoToken from "../../../../../../../utils/parseCryptoToken";
import {Box} from "@material-ui/core";
import {TableItemWithSubtitle} from "../../../../../../helpers/Display";

export const columnsList = [
  {
    minWidth: 300,
    label: 'Terminal',
    dataKey: 'terminal',
    dataHandler: ({terminal_color = '', terminal_name, terminal_id}) => (
      <Box
        width="100%"
        display="flex"

        ml="2rem"
      >
        <TerminalColorDisplay color={terminal_color} />
        <Box>
          <TableItemWithSubtitle
            item={terminal_name}
            subItem={terminal_id && (
              <DisplayIdMerchant>
                {terminal_id}
              </DisplayIdMerchant>
            )}
            alignLeft
          />
        </Box>
      </Box>
    )
  },
  // {
  //   minWidth: 250,
  //   label: 'Order ID',
  //   dataKey: 'order_id',
  //   dataHandler: ({order_id = '', order_description = ''}) => (
  //     <div>
  //       <DisplayIdMerchant>
  //         {order_id}
  //       </DisplayIdMerchant>
  //       {order_description && (
  //         <Tooltip className="f12 lh lts0em c717275 fw4 mt3">
  //           {order_description}
  //         </Tooltip>
  //       )}
  //     </div>
  //   )
  // },
  {
    minWidth: 250,
    label: 'Payment ID',
    dataKey: 'payment_id',
    dataHandler: ({payment_id = ''}) => (
      <DisplayIdMerchant>
        {payment_id}
      </DisplayIdMerchant>
    )
  },
  {
    minWidth: 150,
    label: 'Date',
    dataKey: 'date_time',
    dataHandler: ({date_time}) => (
      <DisplayDateTimeMerchant
        date={date_time}
      />
    )
  },
  {
    minWidth: 150,
    label: 'Amount',
    dataKey: 'amount',
    dataHandler: (row) => {
      const isStablecoin = !!row.sc_amount;
      const currencyAmount = isStablecoin ? row.sc_amount : row.fiat_amount;
      const currencyCode = isStablecoin ? row.sc_code : row.fiat_code;

      const cryptoCurrencyAmount = row.currency_amount;
      const parsedToken = parseCryptoToken(row.currency_code || '-');

      return (
        <div>
          <DisplayAmountFCMerchant
            fiat={{amount: currencyAmount, symbol: currencyCode}}
            crypto={cryptoCurrencyAmount && {
              amount: cryptoCurrencyAmount,
              symbol: parsedToken[1],
            }}
          />
        </div>
      )
    }
  },
  {
    minWidth: 175,
    label: 'Status',
    dataKey: 'tx_status',
    dataHandler: ({transaction_status = ''}) => (
      <div
        className={`f12 lh lts0em c0 cFFBF43.pending c2CE889.completed
                c9C8FFF.requested cEE4F4F.failed c5B47FF.sent c2.cancelled cC4C4C4.expired ` + transaction_status}
      >
        {upperFirst(transaction_status)}
      </div>
    )
  },
];
